window.spsDataLayer = window.spsDataLayer || {};
window.spsDataLayer.internal = window.spsDataLayer.internal || {};

const getGoogleMapsConsent = async (): Promise<boolean | undefined> => {
    const UC = window.UC_UI;
    if (!UC?.getServicesBaseInfo) return false;

    try {
        const services = await UC.getServicesBaseInfo();
        if (!Array.isArray(services)) return false;

        const googleMaps = services.find(s => s.name === 'Google Maps');

        return googleMaps?.consent?.status;
    } catch {
        return false;
    }
};

window.spsDataLayer.internal.getGoogleMapsConsent = getGoogleMapsConsent;

export {};
